import { PageLoading } from 'components/loading'
import { useFatoAtividadeColetivaSaudeQuery } from 'graphql/hooks.generated'
import React from 'react'
import { Redirect, useParams } from 'react-router'
import { convertFatoAtividadeColetivaSaudeToAtividadeColetiva } from 'view/atividade-coletiva/converter-atividadeColetiva'

import { AtividadeColetivaVisualizarSaudeView } from './AtividadeColetivaVisualizarSaudeView'

interface FatoAtividadeColetivaSaudeViewParams {
  atividadeColetivaId: ID
}

export function FatoAtividadeColetivaSaudeView() {
  const { atividadeColetivaId } = useParams<FatoAtividadeColetivaSaudeViewParams>()

  const {
    data: { fatoAtividadeColetiva },
    loading,
  } = useFatoAtividadeColetivaSaudeQuery({
    variables: { input: atividadeColetivaId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!fatoAtividadeColetiva) {
    return <Redirect to='/404' />
  } else {
    return (
      <AtividadeColetivaVisualizarSaudeView
        atividadeColetiva={convertFatoAtividadeColetivaSaudeToAtividadeColetiva(fatoAtividadeColetiva)}
        isFonteDadosPec={false}
      />
    )
  }
}
